export const messages = {
  label: { id: 'admin/promotions.form.general.name' },
  validation: {
    required: { id: 'admin/promotions.form.validation.required' },
    maxLength: { id: 'admin/promotions.form.validation.max-length' },
  },
}
